module.exports = __webpack_public_path__ + "media/content-creator/health-2-cc904b25.png";